module.exports = __webpack_public_path__ + "img/20201107_094727.c22eecb0.jpg";